import React from 'react';

const WhiteLabelContext = React.createContext(null);

export default WhiteLabelContext;